import Api from '@/services/Api'

export default {
  getList () {
    return Api().get('/dns/')
  },


  getCompleteList () {
    return Api().get('/all_domains_list/')
  },

  get (domain) {
    return Api().get('/dns/' + domain)
  },

  updateRecords (domain, records) {
    return Api().put('/dns/' + domain, {
      records: records
    })
  }
}
